import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LocationsInternalClient, CreateLocationRequest } from '../nswag/atlas/AtlasClient';

export default function useCreateOrganisation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (request: ICreateOrganisationRequest) => {
      const client = new LocationsInternalClient();
      return await client.createOrganisation(request.createLocationRequest);
    },
    onSuccess: (_, request) => {
      queryClient.invalidateQueries({ queryKey: ['CUSTOMER', request.customerId] });
    },
  });
}

interface ICreateOrganisationRequest {
  createLocationRequest: CreateLocationRequest;
  customerId: string;
}
